function normalizeRid(value) {
  if (value == null) return null;
  var rid = typeof value === 'object' && value['@rid'] ? value['@rid'] : value;
  rid = String(rid);
  if (!rid) return null;
  return rid.charAt(0) === '#' ? rid : '#' + rid;
}

function buildClassOptions(tree) {
  var categories = tree && Array.isArray(tree.categories) ? tree.categories : [];
  var options = [];
  var traverse = function (node, path) {
    if (!node || !node.name) return;
    var currentPath = path ? path + ' > ' + node.name : node.name;
    options.push({ value: node.name, key: currentPath });
    (Array.isArray(node.children) ? node.children : []).forEach(function (child) {
      traverse(child, currentPath);
    });
  };
  categories.forEach(function (category) { traverse(category, ''); });
  return options;
}

function normalizeFieldDiscovery(fieldDiscovery, formatUnit) {
  var pointUnit = typeof formatUnit === 'function'
    ? formatUnit
    : function (point) { return point && (point.displayUnit || point.destUnit || point.unit) || ''; };
  var discoveredDatasets = fieldDiscovery && Array.isArray(fieldDiscovery.datasets)
    ? fieldDiscovery.datasets
    : [];
  var datasets = [];

  discoveredDatasets.forEach(function (dataset, datasetIndex) {
    if (!dataset) return;
    var datasetName = dataset.datasetName || dataset.name || 'Dataset';
    var equipmentLabel = dataset.equipmentName || dataset.className || 'Equipment';
    var equipmentRid = normalizeRid(dataset.equipmentRid);
    var parentEquipmentRid = normalizeRid(dataset.parentEquipmentRid);
    var parentEquipmentLabel = dataset.parentEquipmentName || '';
    var scopeEquipmentRid = parentEquipmentRid || equipmentRid;
    var scopeEquipmentLabel = parentEquipmentLabel || equipmentLabel;
    var groupKey = dataset.groupKey || 'Dataset::' + datasetName;
    var datasetKey = (dataset.rid || dataset.key || 'dataset-' + datasetIndex) + '::' + (equipmentRid || '');
    var points = [];

    (Array.isArray(dataset.points) ? dataset.points : []).forEach(function (discoveredPoint, pointIndex) {
      if (!discoveredPoint) return;
      var pointRecord = discoveredPoint.point || {};
      var pointRid = normalizeRid(discoveredPoint.pointRid || discoveredPoint.rid || pointRecord['@rid']);
      var columnName = discoveredPoint.name || pointRecord.name || 'Point ' + (pointIndex + 1);
      var unitLabel = pointUnit(pointRecord);
      var datasetLabelPart = datasetName && datasetName !== 'Default' ? ' – ' + datasetName : '';
      var seriesLabel = equipmentLabel + datasetLabelPart + ' – ' + columnName + (unitLabel ? ' (' + unitLabel + ')' : '');
      points.push({
        key: discoveredPoint.columnRid || datasetKey + '::' + columnName + '::' + pointIndex,
        name: columnName,
        pointRid: pointRid,
        unitLabel: unitLabel,
        datasetName: datasetName,
        chartType: discoveredPoint.chartType || discoveredPoint.type || 'line',
        point: pointRecord,
        seriesLabel: seriesLabel,
        equipmentLabel: equipmentLabel,
        equipmentRid: equipmentRid,
        parentEquipmentRid: parentEquipmentRid,
        parentEquipmentLabel: parentEquipmentLabel,
        scopeEquipmentRid: scopeEquipmentRid,
        scopeEquipmentLabel: scopeEquipmentLabel,
        equipmentClass: dataset.className,
        groupKey: groupKey,
        pathKey: groupKey + '::' + columnName,
        disabled: !pointRid
      });
    });

    datasets.push({
      key: datasetKey,
      name: datasetName,
      displayName: datasetName,
      equipmentLabel: equipmentLabel,
      equipmentRid: equipmentRid,
      parentEquipmentRid: parentEquipmentRid,
      parentEquipmentLabel: parentEquipmentLabel,
      scopeEquipmentRid: scopeEquipmentRid,
      scopeEquipmentLabel: scopeEquipmentLabel,
      equipmentClass: dataset.className,
      componentDepth: Number(dataset.componentDepth) || 0,
      groupKey: groupKey,
      points: points
    });
  });

  return datasets;
}

function buildEquipmentOptions(fieldDiscovery) {
  var equipment = fieldDiscovery && Array.isArray(fieldDiscovery.equipment)
    ? fieldDiscovery.equipment
    : [];
  var seen = new Set();
  return equipment.filter(function (record) {
    if (!record || Number(record.componentDepth) > 0) return false;
    var rid = normalizeRid(record.rid || record['@rid']);
    if (!rid || seen.has(rid)) return false;
    seen.add(rid);
    return true;
  }).map(function (record) {
    var rid = normalizeRid(record.rid || record['@rid']);
    var name = record.name || record.className || record['@class'] || rid;
    var className = record.className || record['@class'] || '';
    return {
      value: rid,
      key: className && className !== name ? name + ' — ' + className : name,
      name: name,
      className: className
    };
  }).sort(function (a, b) {
    return String(a.key).localeCompare(String(b.key), undefined, { numeric: true, sensitivity: 'base' });
  });
}

function filterDatasetsByEquipment(datasets, equipmentRids) {
  var selected = new Set((Array.isArray(equipmentRids) ? equipmentRids : [])
    .map(normalizeRid)
    .filter(Boolean));
  if (!selected.size) return [];
  return (Array.isArray(datasets) ? datasets : []).filter(function (dataset) {
    var scopeRid = normalizeRid(dataset && (dataset.scopeEquipmentRid || dataset.parentEquipmentRid || dataset.equipmentRid));
    return scopeRid && selected.has(scopeRid);
  });
}

function buildPointGroups(datasets, equipmentOptions) {
  var totalEquipment = Array.isArray(equipmentOptions) ? equipmentOptions.length : 0;
  var groups = new Map();
  (Array.isArray(datasets) ? datasets : []).forEach(function (dataset) {
    if (!dataset || !Array.isArray(dataset.points)) return;
    dataset.points.forEach(function (point) {
      if (!point || !point.pointRid) return;
      var pathKey = point.pathKey || (dataset.groupKey || dataset.name || 'Dataset') + '::' + point.name;
      if (!groups.has(pathKey)) {
        groups.set(pathKey, {
          value: pathKey,
          baseLabel: (dataset.displayName || dataset.name || 'Dataset') + ' - ' + (point.name || 'Point'),
          pathKey: pathKey,
          points: []
        });
      }
      var exportName = [
        point.equipmentLabel,
        point.datasetName && point.datasetName !== 'Default' ? point.datasetName : null,
        point.name
      ].filter(Boolean).join(' – ');
      groups.get(pathKey).points.push({
        pointRid: point.pointRid,
        columnName: exportName || point.name || point.pointRid,
        equipmentLabel: point.equipmentLabel,
        scopeEquipmentRid: point.scopeEquipmentRid,
        scopeEquipmentLabel: point.scopeEquipmentLabel,
        datasetName: point.datasetName,
        sourcePointName: point.point && point.point.name ? point.point.name : '',
        unit: point.unitLabel || ''
      });
    });
  });

  return Array.from(groups.values()).map(function (group) {
    var matchedEquipment = new Set(group.points.map(function (point) {
      return normalizeRid(point.scopeEquipmentRid);
    }).filter(Boolean));
    group.matchedEquipmentCount = matchedEquipment.size;
    group.totalEquipmentCount = totalEquipment;
    group.key = group.baseLabel + ' (' + group.matchedEquipmentCount + '/' + totalEquipment + ')';
    return group;
  }).sort(function (a, b) {
    return String(a.key).localeCompare(String(b.key), undefined, { numeric: true, sensitivity: 'base' });
  });
}

function buildCoverage(pointGroups, selectedPointGroups, equipmentOptions) {
  var selected = new Set(Array.isArray(selectedPointGroups) ? selectedPointGroups : []);
  var equipment = Array.isArray(equipmentOptions) ? equipmentOptions : [];
  var equipmentByRid = new Map(equipment.map(function (option) {
    return [normalizeRid(option.value), option];
  }));
  var rows = [];
  var seenColumns = new Set();

  (Array.isArray(pointGroups) ? pointGroups : []).forEach(function (group) {
    if (!group || !selected.has(group.value)) return;
    var matched = new Set();
    var sourceNames = new Set();
    (group.points || []).forEach(function (point) {
      var scopeRid = normalizeRid(point.scopeEquipmentRid);
      if (scopeRid) matched.add(scopeRid);
      if (point.sourcePointName) sourceNames.add(point.sourcePointName);
      if (point.pointRid) seenColumns.add(point.pointRid + '|' + point.columnName);
    });
    var missing = equipment.filter(function (option) {
      return !matched.has(normalizeRid(option.value));
    });
    rows.push({
      value: group.value,
      label: group.baseLabel || group.key,
      matchedCount: matched.size,
      totalCount: equipment.length,
      missingCount: missing.length,
      missingEquipment: missing.map(function (option) { return option.name || option.key; }),
      sourcePointNames: Array.from(sourceNames).sort(function (a, b) {
        return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
      })
    });
  });

  return {
    equipmentCount: equipmentByRid.size,
    pointDefinitionCount: rows.length,
    columnCount: seenColumns.size,
    missingDefinitionCount: rows.filter(function (row) { return row.missingCount > 0; }).length,
    rows: rows
  };
}

module.exports = {
  buildClassOptions: buildClassOptions,
  normalizeFieldDiscovery: normalizeFieldDiscovery,
  buildEquipmentOptions: buildEquipmentOptions,
  filterDatasetsByEquipment: filterDatasetsByEquipment,
  buildPointGroups: buildPointGroups,
  buildCoverage: buildCoverage,
  normalizeRid: normalizeRid
};
